module.exports = __webpack_public_path__ + "img/accountantOrange.412737cd.png";